import { ActionContext } from "vuex";

import IPayloadQuery from "@/interfaces/IPayloadQuery";
import IState from "@/interfaces/IState";
import { extractFullData } from "@/libs/backend/apimapper";

export default async (
  context: ActionContext<IState, IState>,
  payload: IPayloadQuery
) => {
  const campaigns = await context.dispatch("backendTalker", {
    request: "campaigns_list",
    query: payload.query,
  });

  return extractFullData(campaigns.data);
};
